import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { split, ApolloLink } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';


Vue.use(VueApollo);

const AUTH_TOKEN = 'hey-access-token';
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4040/api/v1/graphql';
const wsEndpoint = process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4040/subscriptions';

// Call this in the Vue app file
export function createProvider() {
  // HTTP connection to the API
  const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: httpEndpoint,
  });

  const middlewareLink = new ApolloLink((operation, forward) => {
    const token = localStorage.getItem(AUTH_TOKEN);
    operation.setContext({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return forward(operation);
  });

  // Cache implementation
  const cache = new InMemoryCache();

  const wsLink = new WebSocketLink({
    uri: wsEndpoint,
    options: {
      reconnect: true,
      connectionParams: () => {
        const token = localStorage.getItem(AUTH_TOKEN);
        return { token };
      },
    },
  });

  const link = split(
    // split based on operation type
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    middlewareLink.concat(httpLink),
  );

  // Create the apollo client
  const apolloClient = new ApolloClient({
    link,
    cache,
    connectToDevTools: true,
  });

  // Create vue apollo provider
  return new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
    },
  });
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token);
  }

  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message);
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN);
  }

  try {
    await apolloClient.resetStore();
    localStorage.removeItem('currentCompany');
    localStorage.removeItem('currentCampaign');
    localStorage.removeItem('currentChannel');
    localStorage.removeItem('currentAgent');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
  }
}

// Get Token
export function getToken(tokenName = AUTH_TOKEN) {
  return localStorage.getItem(tokenName);
}
